import React from "react";

const PaginationSelectorItem = props => (
	<li className="offers-pagination--li" key={props.value}>
		<button
			className={`offers-pagination--li--button ${
				props.currentPage === props.value ? "current-page" : ""
			}`}
			onClick={e => props.onClick()}
		>
			{props.value}
		</button>
	</li>
);

export default PaginationSelectorItem;
